import React, { useState } from "react";
import { Container, Form, Row, Col, Button, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function TerminalAvailability({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    terminal_availability: false,
    other_terminals: false,
    any_other_available_terminal: false,
  });
  


  
  const MAIN_TERMINALS = [
    // { name: "Maya", field: "terminal_maya" },
    { name: "Gcash Terminal", field: "terminal_gcash" },
    { name: "Gcash Sound Pay", field: "gcash_sound_pay" },
    { name: "BDO", field: "terminal_bdo" },
    { name: "Metrobank", field: "terminal_metrobank" },
    { name: "BPI", field: "terminal_bpi" },
    { name: "Global Payments", field: "terminal_global_payments" }
  ];


  const OTHER_TERMINALS = [
    { name: "UnionBank", field: "terminal_unionbank" },
    { name: "HSBC", field: "terminal_hsbc" },
    { name: "Maybank", field: "terminal_maybank" },
    { name: "RCBC", field: "terminal_rcbc" },
    { name: "Stripe Payments", field: "terminal_stripe_payments" },
    { name: "GHL", field: "terminal_ghl" },
    { name: "Citibank", field: "terminal_citibank" },
    { name: "PNB", field: "terminal_pnb" },
    { name: "Robinsons Bank", field: "terminal_robinsons_bank" }
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === "checkbox") {
      setPrimaryDetails(prev => ({
        ...prev,
        [name]: checked
      }));
    } else {
      setPrimaryDetails(prev => ({
        ...prev,
        [name]: value
      }));
    }

    if (isError[name]) {
      setIsError(prev => ({
        ...prev,
        [name]: false
      }));
    }
  };

  const validateForm = () => {
    const errors = {};

    const hasMainTerminalSelection = MAIN_TERMINALS.some(terminal => 
      primaryDetails[`${terminal.field}_yes`] || primaryDetails[`${terminal.field}_no`]
    );
    
    if (!hasMainTerminalSelection) {
      errors.terminal_availability = true;
      toast.error("Please select at least one terminal availability option", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
    }

    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    const hasMainTerminalSelection = MAIN_TERMINALS.some(terminal => 
      primaryDetails[`${terminal.field}_yes`] || primaryDetails[`${terminal.field}_no`]
    );
    return hasMainTerminalSelection;
  };
  const handleNext = () => {
    if (!validateForm()) return;

    const selectedFrom = (list) =>
      list
        .filter(t => primaryDetails[`${t.field}_yes`])
        .map(t => t.name);

    const available_terminal = selectedFrom(MAIN_TERMINALS);
    const other_available_terminal = selectedFrom(OTHER_TERMINALS);

    setPrimaryDetails(prev => ({
      ...prev,
      available_terminal: JSON.stringify(available_terminal),
      other_available_terminal: JSON.stringify(other_available_terminal),
      any_other_available_terminal: primaryDetails.any_other_available_terminal || undefined,
    }));

    navigation.go("sqr-availability");
  };

  // const handleModalClose = () => {
  //   setShowModal(false);
  //   // Continue navigation after preview
  //   navigation.go("sqr-availability");
  // };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">
                  TERMINAL AVAILABILITY
                </h4>
                <p className="form-desc">
                  Please indicate terminal availability
                </p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">

                  <Form.Group className="mb-5" controlId="terminal_availability">
                    <Form.Label className="form-label">
                      Terminal Availability <span className="form-required">*</span>
                    </Form.Label>
                    

                    <div className="promo-grid-header">
                      <div>Terminal</div>
                      <div className="text-center">Yes</div>
                      <div className="text-center">No</div>
                    </div>

                    {/* Main Terminals */}
                    {MAIN_TERMINALS.map((terminal, index) => (
                      <div key={index} className="promo-grid-row">
                        <div className="grid-item-name">
                          {terminal.name}
                        </div>
                        <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={terminal.field}
                            value="yes"
                            checked={primaryDetails[`${terminal.field}_yes`] || false}
                            onChange={(e) => {
                              setPrimaryDetails(prev => ({
                                ...prev,
                                [`${terminal.field}_yes`]: e.target.checked,
                                [`${terminal.field}_no`]: false
                              }));
                            }}
                          />
                        </div>
                        <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={terminal.field}
                            value="no"
                            checked={primaryDetails[`${terminal.field}_no`] || false}
                            onChange={(e) => {
                              setPrimaryDetails(prev => ({
                                ...prev,
                                [`${terminal.field}_no`]: e.target.checked,
                                [`${terminal.field}_yes`]: false
                              }));
                            }}
                          />
                        </div>
                      </div>
                    ))}

                    {isError.terminal_availability && (
                      <div className="form-error">
                        Please select terminal availability options
                      </div>
                    )}
                  </Form.Group>

                  {/* Other Terminals Section */}
                  <Form.Group className="mb-5" controlId="other_terminals">
                    <Form.Label className="form-label">
                      Other terminals
                    </Form.Label>

                    {/* Header Row */}
                    <div className="form-radio-item" style={{
                      display: "grid",
                      gridTemplateColumns: "2fr 1fr 1fr",
                      gap: "1rem",
                      fontWeight: "600"
                    }}>
                      <div>Terminal</div>
                      <div style={{ textAlign: "center" }}>Yes</div>
                      <div style={{ textAlign: "center" }}>No</div>
                    </div>

                    {/* Other Terminals */}
                    {OTHER_TERMINALS.map((terminal, index) => (
                      <div key={index} className="promo-grid-row">
                        <div className="grid-item-name">
                          {terminal.name}
                        </div>
                        <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={terminal.field}
                            value="yes"
                            checked={primaryDetails[`${terminal.field}_yes`] || false}
                            onChange={(e) => {
                              setPrimaryDetails(prev => ({
                                ...prev,
                                [`${terminal.field}_yes`]: e.target.checked,
                                [`${terminal.field}_no`]: false
                              }));
                            }}
                          />
                        </div>
                        <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={terminal.field}
                            value="no"
                            checked={primaryDetails[`${terminal.field}_no`] || false}
                            onChange={(e) => {
                              setPrimaryDetails(prev => ({
                                ...prev,
                                [`${terminal.field}_no`]: e.target.checked,
                                [`${terminal.field}_yes`]: false
                              }));
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </Form.Group>

                  <Form.Group className="mb-5" controlId="any_other_available_terminal">
                    <Form.Label className="form-label">
                      Other terminals, if any
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="any_other_available_terminal"
                      value={primaryDetails.any_other_available_terminal || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Modal to preview backend response */}
      {/* <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Backend Response Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre>{JSON.stringify(backendResponse, null, 2)}</pre>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleModalClose}>
            Continue
          </Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
}

export default TerminalAvailability;
